import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=dbc89a52&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&lang=ts"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=dbc89a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc89a52",
  null
  
)

export default component.exports